export enum MessageAuthor{
    PROVIDER = 'PROVIDER',
    CLIENT = 'CLIENT'
}


// WEBPACK FOOTER //
// ./src/types/enums/MessageAuthor.ts